export const arrayforMulti = (array) => {
    let newArray = []
    array = array || [];
    if (array.length > 0) {
        if (array[0].customername) {
            for (let a = 0; a < array.length; a++) {
                newArray.push({
                    value: array[a]._id,
                    label: array[a].customername,
                    object: array[a]
                })
            }
        }
        else if (array[0].firstname) {
            for (let a = 0; a < array.length; a++) {
                newArray.push({
                    value: array[a]._id,
                    label: array[a].firstname + " " + array[a].lastname,
                    object: array[a]
                })
            }
        }
        else {
            for (let a = 0; a < array.length; a++) {
                newArray.push({
                    value: array[a]._id,
                    label: array[a].name,
                    object: array[a]
                })
            }
        }
    }
    return newArray
}